import React from 'react';

const ExportIcon = ({ ...rest }) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" {...rest}>
            <ask id="mask0_1604_435" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                <rect width="24" height="24" fill="#D9D9D9" />
            </ask>
            <g mask="url(#mask0_1604_435)">
                <path d="M7.25 19.5V18H16.75V19.5H7.25ZM11.25 15.8077V7.35375L8.3905 10.198L7.34625 9.15375L12 4.5L16.6538 9.15375L15.6095 10.198L12.75 7.35375V15.8077H11.25Z" fill="#212121" />
            </g>
        </svg>
    );
};

export default ExportIcon;